<template>
    <div class="footer">
        <div class="wrap">
            <!-- <img class="slogan" src="../assets/img/component/footer/fg_logo.svg" alt="funghouse"> -->
            <div class="group">
                <a :href="iosUrl" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/component/footer/apple.png" alt="">
                </a>
                <a :href="androidUrl" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/component/footer/google.png" alt="">
                </a>
            </div>
            <div class="social">
                <!-- <a :href="androidUrl" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/social/instagram.png" alt="">
                </a> -->
                <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/social/line.png" alt="">
                </a>
                <!-- <a :href="androidUrl" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/social/facebook.png" alt="">
                </a> -->
            </div>
            <span class="right">方居浩斯版權所有© {{year}} &nbsp;|&nbsp;  <router-link :to="{ name: 'privateAndPolicy'}">隱私權政策與使用條款</router-link></span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        year: function () {
            let d = new Date();
            let year = d.getFullYear();

            return year
        },
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            iosUrl: 'GET_IOS_URL',
            androidUrl: 'GET_ANDROID_URL',
        })
    },
}
</script>
<style lang="scss" scoped>
    .footer{
        display: flex;
        justify-content: center;
        padding: 50px 0;
        background-color: #ffffff;
        .wrap{
            text-align: center;
            .slogan{
                margin-bottom: 36px;
            }
            .group{
                margin-bottom: 4px;
                img:first-child{
                    margin-right: 8px;
                }
                img{
                    width: 139px;
                }
            }
            .social{
                img{
                    width: 32px;
                    height: 32px;
                    margin: 26px 8px;
                }
            }
            .right{
                font-weight: 300;
            }
        }
    }
    @media screen and (max-width: 360px) {
        .footer{
            .wrap{
                .slogan{
                    margin-bottom: 30px;
                }
                .group{
                    margin-bottom: 20px;
                    img:first-child{
                        margin-right: 8px;
                    }
                    img{
                        width: 133px;
                    }
                }
                .right{
                    font-size: 12px;
                    font-weight: 300;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue